module.exports = __webpack_public_path__ + "static/media/sub-table-sample-1.de348471.png";